<template>
  <div class="wf-event-listing">
    <div class="container-fluid">
      <div class="wf-event-listing-controls">
        <div class="wf-event-listing-controls-item">
          <label class="input-label" for="event-filter">
            Event type:
          </label>
          <select
            class="custom-select"
            name="event-filter"
            id="event-filter"
            v-model="eventFilter"
          >
            <option
              v-for="filterOption in eventFilterOptions"
              :key="filterOption"
              :value="filterOption"
            >
              {{ filterOption }}
            </option>
          </select>
        </div>
      </div>
      <div class="wf-event-listing-items">
        <slot :eventFilter="eventFilter">
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'eventFilterOptions' : Array
  },
  data() {
    return {
      'eventFilter': 'All'
    }
  }
}
</script>